export const buildExcelData = <T>(
  data: T[],
  columns: {
    header: string;
    key: keyof T | string;
    formatter?: (row: T) => any;
  }[]
) => {
  return data.map((row, index) => {
    const record: any = { 'Sr No': index + 1 };

    columns.forEach((col) => {
      record[col.header] = col.formatter
        ? col.formatter(row)
        : (row as any)[col.key];
    });

    return record;
  });
};
